module.exports = __webpack_public_path__ + "img/loginLogo1.png";